import { render } from "./FamiliasListado.vue?vue&type=template&id=62ce97e7&ts=true"
import script from "./FamiliasListado.vue?vue&type=script&lang=ts"
export * from "./FamiliasListado.vue?vue&type=script&lang=ts"

import "./FamiliasListado.vue?vue&type=style&index=0&id=62ce97e7&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__